var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcons8Text(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#90CAF9",
    d: "M40 45L8 45 8 3 30 3 40 13z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E1F5FE",
    d: "M38.5 14L29 14 29 4.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1976D2",
    d: "M16 21H33V23H16zM16 25H29V27H16zM16 29H33V31H16zM16 33H29V35H16z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Text);
export default __webpack_public_path__ + "static/media/icons8-text.97abe01d07bf80e4eda91ea57d1096d9.svg";
export { ForwardRef as ReactComponent };